import { DefaultValues } from 'react-hook-form';
import { z } from 'zod';

import {
  termsFormDataDefault,
  termsFormDataSchema,
} from '~/components/NegotiationTermsForm/NegotiationTermsForm.schema';
import {
  demandRequestFormDataDefault,
  demandRequestFormDataSchema,
} from '~/modules/DemandRequestWidget/components/DemandRequestDetailsForm/DemandRequestDetailsForm.schema';
import {
  supplierContactFormDataDefault,
  supplierContactFormDataSchema,
} from '~/modules/NegotiationSupplierContactWidget/components/SupplierContactForm/SupplierContactForm.schema';

export const negotiationCreateFormDataSchema = z.object({
  ...supplierContactFormDataSchema.shape,
  ...demandRequestFormDataSchema.shape,
  ...termsFormDataSchema.shape,
});

export type NegotiationCreateFormData = z.infer<typeof negotiationCreateFormDataSchema>;

export const negotiationCreateFormDataDefault: DefaultValues<NegotiationCreateFormData> = {
  ...supplierContactFormDataDefault,
  ...demandRequestFormDataDefault,
  ...termsFormDataDefault,
};
